import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { Advertising } from '../interfaces/advertising';
import { IItem, OrganizationType } from '../interfaces/organizations';
import { IEventSource, itemLabelFactory, makeMainGEvent, pushEvent } from '../utils/analytics';

export const EVENT_CATEGORY = 'Отзывы';

export interface IAnalyticsItem {
  advertising?: Advertising.IItem;
  name: string;
  organization: {
    name: string;
  };
}

/** AD G_EVENTS **/

export const sendAuthEvent = () => {
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Прочее',
      eventAction: 'Вход в ЛК',
      eventLabel: 'Авторизация по номеру',
    }),
  );
};

export const sendReviewEvent = ({ label, action }: { label: string | string[]; action: string | string[] }) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: action,
      eventLabel: label,
    }),
  );
};

export const sendWriteReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Написать отзыв',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendSolveReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Проблема решена',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendCommentToReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Комментировать',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendLikeReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Лайк',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendUnlikeReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Снятие лайка',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendShareReviewEvent = (item: IAnalyticsItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Поделиться',
      eventLabel: itemLabelFactory(item),
    }),
  );
};

export const sendPaidClickEvent = (item: IItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Микрокредиты',
      eventAction: 'Платный клик|Карточка компании',
      eventLabel: item.name,
      eventValue: item.ad?.clickCost,
    }),
  );
};

export const sendAdSchoolClickEvent = (item: IItem) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: 'Курсы',
      eventAction: 'Платный клик',
      eventLabel: item.name,
    }),
  );
};

export const sendProductClickEvent = (event: Partial<IEventSource>) => {
  pushEvent(
    makeMainGEvent({
      ...event,
    }),
  );
};

export const sendProductViewEvent = (event: Partial<IEventSource>) => {
  pushEvent(
    makeMainGEvent({
      eventAction: 'Показ',
      ...event,
    }),
  );
};

export const sendSqueezeOnEvent = (label: string) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Фильтр|Выжимка',
      eventLabel: label,
    }),
  );
};

export const sendSqueezeOffEvent = (label: string) => {
  pushEvent(
    makeMainGEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Отмена фильтра|Выжимка',
      eventLabel: label,
    }),
  );
};

const PAGE_VIEW_GA_STATE: { title: string; path: string } = {
  title: '',
  path: '',
};

export const checkAndSendPageViewGAEvent = (title, path) => {
  if (title !== PAGE_VIEW_GA_STATE.title && path !== PAGE_VIEW_GA_STATE.path) {
    if (PAGE_VIEW_GA_STATE.title && PAGE_VIEW_GA_STATE.path) {
      pushEvent({
        event: 'pageViewGA',
        title,
        path,
      });
    }

    Object.assign(PAGE_VIEW_GA_STATE, {
      title,
      path,
    });
  }
};

export interface IAnalyticsObject {
  name: string;
  organization: {
    name: string;
  };
  position?: string | number;
}

export const getAnalyticsObject = (
  organizationName: string,
  type: PAGE_TYPE,
  products?: { [key in OrganizationType]?: string[] },
  position?: string | number,
): IAnalyticsObject => {
  const orgHelper = getOrganizationHelpers(type, products);

  const obj = {
    name: orgHelper?.namesType?.bigFirstCharMulti,
    organization: {
      name: organizationName,
    },
    position,
  };

  return obj;
};
